<template>
  <b-row>
    <b-col cols="12">
      <schedules-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import SchedulesTable from './SchedulesTable.vue'

export default {
  components: {
    BRow,
    BCol,

    SchedulesTable,

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
@import '@core/scss/vue/libs/vue-good-table';
</style>
